import { Icon } from '@ps/isp-web-component-library';
import { ChevronMediumDown } from '@ps/isp-web-component-library/icons/ChevronMediumDown';
import type { MarketId } from '@ps/isp-web-services-types';
import type { Values } from '@ps/web-core-intl';
import { Link, Translation } from '@ps/web-shared-components';
import type { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';

import { useSportsNextRacesWidget } from '../model';

import { TXTWCL_View_Full_Race_Card } from './ViewFullRaceCard.messages.json';
import styles from './ViewFullRaceCard.scss';

const ViewFullRaceCard: FunctionComponent<{ marketId: MarketId }> = ({ marketId }) => {
  const { widgetSelect } = useSportsNextRacesWidget();

  const raceCardLinkValues = useSelector((state: RootState) =>
    widgetSelect.raceCardLinkValues(state, marketId)
  );

  return (
    <Link
      className={styles.viewFullLink}
      alias="sportsAnimalRacingRace"
      values={raceCardLinkValues as unknown as Values}
    >
      <Translation {...TXTWCL_View_Full_Race_Card} />
      <Icon icon={ChevronMediumDown} size="x1" />
    </Link>
  );
};

export default ViewFullRaceCard;
